// Embedded in the UI bundle: this identifies the code actually loaded by the
// PWA, independently of the server's /api/config version.
declare const __NYX_APP_VERSION__: string;
declare const __NYX_APP_REVISION__: string;

export const appVersion = __NYX_APP_VERSION__;
export const appRevision = __NYX_APP_REVISION__;
